export default __webpack_public_path__ + "static/media/icon-card-trips.c112875b.svg";